import { ComisionistState } from 'types/redux/state/comisionist.state';
import { ComisionistAction, ComisionistActions } from 'types/redux/actions/comisionist.action';
import { initComisionistState } from 'redux/initial.state';
import produce from 'immer';
import { setLoadable } from 'utils/state.handlers';

export const comisionistReducer = (
  state: ComisionistState = initComisionistState(),
  action: ComisionistAction,
): ComisionistState =>
  produce(state, (clone) => {
    switch (action.type) {
      case ComisionistActions.update:
        setLoadable(clone, action.isLoading, action.error);
        break;

      case ComisionistActions.fetchList:
        clone.list.comisionistas = action.comisionistas;
        clone.list.meta = action.meta;
        setLoadable(clone, false);
        break;

      case ComisionistActions.fetchDetail:
        clone.detail = action.detail;
        clone.selectedComisionist = {
          id: action.detail.id,
          account: action.detail.account,
          name: action.detail.name,
          type: action.detail.type,
          dui: action.detail.dui,
          nit: action.detail.nit,
          nrc: action.detail.nrc,
          status: action.detail.status,
          documentsStatus: action.detail.documentsStatus,
          dateHighAS400: action.detail.dateHighAS400,
          synchronized: action.detail.synchronized,
          dateSynchronized: action.detail.dateSynchronized,
          branchOffice: action.detail.branchOffice,
          branchOfficeId: action.detail.branchOfficeId,
          isLargeContributor: action.detail.isLargeContributor,
          createdAt: action.detail.createdAt,
          updatedAt: action.detail.updatedAt,
          identityDoc: action.detail.identityDoc,
          nrcDoc: action.detail.nrcDoc,
          signedFile: action.detail.signedFile,
          verified: action.detail.verified,
        };
        setLoadable(clone, false);
        break;

      case ComisionistActions.setFilter:
        clone.filter = action.filter;
        break;

      case ComisionistActions.createItem:
        clone.list.comisionistas.unshift(action.comisionist);
        setLoadable(clone, false);
        break;

      case ComisionistActions.updateItem:
        const indexUpdate = clone.list.comisionistas.findIndex(
          (c) => c.id === action.comisionist.id,
        );
        if (indexUpdate >= 0) {
          clone.list.comisionistas[indexUpdate] = action.comisionist;
        }
        if (clone.detail && clone.detail.id === action.comisionist.id) {
          // Mantener los datos adicionales del detail si existen
          clone.detail = {
            ...clone.detail,
            ...action.comisionist,
          };
        }
        setLoadable(clone, false);
        break;

      case ComisionistActions.deleteItem:
        clone.list.comisionistas = clone.list.comisionistas.filter(
          (c) => c.id !== action.id,
        );
        setLoadable(clone, false);
        break;

      case ComisionistActions.uploadDocument:
        if (clone.detail && clone.detail.id === action.comisionistId) {
          // Actualizar el estado del documento después de subir
          clone.detail = {
            ...clone.detail,
            documents: clone.detail.documents || [],
          };
        }
        setLoadable(clone, false);
        break;

      case ComisionistActions.clearDetail:
        clone.detail = null;
        clone.selectedComisionist = null;
        break;

      case ComisionistActions.clearError:
        clone.error = undefined;
        break;

      case ComisionistActions.setStats:
        clone.stats = action.stats;
        setLoadable(clone, false);
        break;

      default:
        break;
    }
  });
